"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

function _default() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!url) {
    return [];
  }

  return url.split('|').reduce(function (acc, smarttag) {
    var _smarttag$split = smarttag.split(':'),
        _smarttag$split2 = (0, _slicedToArray2["default"])(_smarttag$split, 3),
        key = _smarttag$split2[0],
        values = _smarttag$split2[1],
        rest = _smarttag$split2[2];

    if (typeof rest === 'undefined') {
      // smarttag should have only two parts
      acc.push({
        key: key,
        values: values.split(',').map(function (value) {
          return {
            key: value
          };
        })
      });
    } // otherwise continue


    return acc;
  }, []);
}